import React from "react";

import { useDispatch, useSelector } from "react-redux";

import DialogBox from "../common/DialogBox";
import ContactUsForm from "./ContactUsForm";
import { getObjLength } from "../helpers/utils";
import PlainAlertMessage from "../common/PlainAlertMessage";
import { agentsAdminAction } from "../../redux/slices/brokers/agentAdminSlice";

import "./attorney-page.scss";
const AttorneyContactUsFormModal = ({
  isProgramModal = false,
  setIsProgramModal = () => {},
}) => {
  const dispatch = useDispatch();
  const { contactformData } = useSelector((state) => state?.agentsAdmin);
  const closeContactUsModal = () => {
    setIsProgramModal(false);
    dispatch(agentsAdminAction.fetchUserContactData({}));
  };
  return (
    <DialogBox
      title={
        (!getObjLength(contactformData) || !contactformData?.success) &&
        "Contact form"
      }
      contentClassName={"bg-white p-0"}
      openPopup={isProgramModal}
      setOpenPopup={setIsProgramModal}
      onClose={
        getObjLength(contactformData) && contactformData?.success
          ? false
          : closeContactUsModal
      }
      content={
        !getObjLength(contactformData) || !contactformData?.success ? (
          <div className="property_form">
            <ContactUsForm />{" "}
          </div>
        ) : (
          <PlainAlertMessage
            type="Success"
            openPopup={true}
            onClose={true}
            onCloseFun={closeContactUsModal}
            message={contactformData?.message}
            footer={false}
          />
        )
      }
    />
  );
};

export default AttorneyContactUsFormModal;
